import { render } from "./PreturiFurnizor.vue?vue&type=template&id=9bc341f0&ts=true"
import script from "./PreturiFurnizor.vue?vue&type=script&lang=ts"
export * from "./PreturiFurnizor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__